module.exports = __webpack_public_path__ + "static/media/8.25ba4387.png";